import * as React from "react";
import { Link } from "react-router-dom";
import {
  Building02,
  Clock,
  Users01,
  MessageSquare01,
  Shield01,
  Bell01,
  Tag01,
} from "@velaro/velaro-component-lib";

interface HubCard {
  title: string;
  body: string;
  to: string;
  icon: React.ReactNode;
}

const CARDS: HubCard[] = [
  {
    title: "Company Profile",
    body: "Name, address, timezone, language, logo",
    to: "/admin/site-settings/general-settings",
    icon: <Building02 />,
  },
  {
    title: "Conversation Timers",
    body: "Per-channel auto-close on inactivity, visitor disconnect handling",
    to: "/admin/channels/lifecycle",
    icon: <Clock />,
  },
  {
    title: "Queue & Team Routing",
    body: "Wait thresholds, auto-resolve, tier escalation, bot auto-close",
    to: "/admin/teams",
    icon: <Users01 />,
  },
  {
    title: "AI & Prompts",
    body: "Global prompt, per-channel overrides, bot behavior",
    to: "/admin/site-settings/ai-settings",
    icon: <MessageSquare01 />,
  },
  {
    title: "Privacy & Data",
    body: "Disclosure text, data opt-out, retention policies",
    to: "/admin/site-settings/manage-data-privacy",
    icon: <Shield01 />,
  },
  {
    title: "Operational Alerts",
    body: "Queue/wait thresholds, alert recipients",
    to: "/admin/site-settings/operational-alerts",
    icon: <Bell01 />,
  },
  {
    title: "Condition Presets",
    body: "Reusable condition groups that drop into any workflow",
    to: "/settings/condition-presets",
    icon: <Tag01 />,
  },
];

export default function SettingsHub() {
  return (
    <div className="max-w-6xl mx-auto p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-800">Settings</h1>
        <p className="text-sm text-slate-500 mt-1">
          Everything that affects how your site behaves. Click any section to edit.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {CARDS.map((card) => (
          <Link
            key={card.title}
            to={card.to}
            className="block bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow p-6 border border-slate-100"
          >
            <div className="text-slate-500 mb-3">{card.icon}</div>
            <div className="text-base font-semibold text-slate-800">
              {card.title}
            </div>
            <div className="text-sm text-slate-500 mt-1">{card.body}</div>
            <div className="text-sm text-blue-600 mt-4">Open →</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
